import React, { Component } from 'react';
import { connect } from 'react-redux';
import { 
	Button, 
	Modal, 
	ModalBody, 
	ModalFooter , 
	ModalHeader,
	FormGroup,
	Input,
	FormFeedback
} from 'reactstrap';
import { sendTwoStepsVerification } from '../../store/actions/companyActions';
import ReactDOM from 'react-dom';
class TwoStepsModal extends Component {
	constructor(props) {
	    super(props);
		    this.state = {
		    	modal: this.props.toggleModal,
				code: ["", "", "", "", "", ""],
				errors: {
					validation_code: ""
				},
				loading: false
			};
			this.inputs = [];
	}
	
	toggleModal = (dispatchEvent) => {
		if(dispatchEvent){
			ReactDOM.render(
				<div></div>,
				document.getElementById("two-steps-verification")
			);
		} else {
			ReactDOM.render(
				<div></div>,
				document.getElementById("two-steps-verification")
			);
		}
	}

	handleChange = (value, index) => {
		if (!/^\d?$/.test(value)) return;

		const code = [...this.state.code];
		code[index] = value;

		this.setState({ code }, () => {
			if (value && index < 5) {
				this.inputs[index + 1].focus();
			} else if(value === "" && index > 0){
				this.inputs[index - 1].focus();
			}
		});
	};

	handleSubmit = () => {
		const { data, config } = this.props;
		const fullCode = this.state.code.join("");

		this.setState({ loading: true });

		if (fullCode.length === 6) {
			this.setState({ errors: {}, loading: false });
			let prevData = {};
			if(config.data){
				prevData = JSON.parse(config.data);
			}
			const body = {
				...prevData,
				_two_step_verification_code: fullCode,
				_signature: data.signature
			}
			const url = config.url;
			const method = config.method
			this.props.sendTwoStepsVerification(url, method, body).then(() =>{
				if(this.props.twoSteps && this.props.twoSteps.error){
					if(this.props.twoSteps.message){
						this.setState({
							errors: {
								validation_code: this.props.twoSteps.message
							},
							loading: false  
						})
					} else {
						this.toggleModal();
					}
				} else {
					this.props.promiseResolver(this.props.twoSteps.data);
					this.toggleModal(true);
				}
			});
		} else {
			this.setState({
				errors: {
					validation_code: "Por favor, completa el código de 6 dígitos."
				},
				loading: false
			});
		}
	};

	render () {
		const { json_lang, title, message } = this.props;
		const { code, errors, modal, loading } = this.state;

		return (
			<Modal 
				isOpen={modal}
				toggle={this.toggleModal}
				className={this.props.className || '' }
				style={this.props.style || {}}
			>
				<ModalHeader toggle={this.toggleModal}>
					{ json_lang.two_steps_modal.title }
				</ModalHeader>
				<ModalBody>
					<div className="text-center mt-4 mb-4">
						<h2 className="text-danger">{json_lang.common.attention.toUpperCase()}</h2>
						<h3><b>{title || json_lang.two_steps_modal.default_title}</b></h3>
						{
							message && (
								<h3 className="text-danger"><b>{message}</b></h3>
							)
						}
						<h4 className="mt-1"><b>{json_lang.two_steps_modal.default_message}</b></h4>
					</div>
					<div className="d-flex flex-column justify-content-center">
						<FormGroup>
							<div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
								{code.map((digit, index) => (
									<Input
										key={index}
										type="text"
										maxLength="1"
										value={digit}
										onChange={(e) => this.handleChange(e.target.value, index)}
										invalid={errors.validation_code !== "" && digit === ""}
										innerRef={(input) => (this.inputs[index] = input)}
										style={{ textAlign: "center", width: "40px" }}
									/>
								))}
							</div>
							{errors.validation_code && (
								<FormFeedback style={{ display: "flex", justifyContent: "center" }}>
									{errors.validation_code}
								</FormFeedback>
							)}
						</FormGroup>
					</div>
				</ModalBody>
				<ModalFooter>
					<Button 
						disabled={loading}
						color = "primary"
						onClick = { () => this.handleSubmit() }
					>
						{json_lang.two_steps_modal.send}
					</Button>
					<Button color = "secondary" onClick = {() => this.toggleModal() } >
						{json_lang.common.cancel}
					</Button>
				</ModalFooter>
			</Modal>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		json_lang: state.json_lang,
		twoSteps: state.twoSteps
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		sendTwoStepsVerification: (url, method, body) => dispatch(sendTwoStepsVerification(url, method, body)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(TwoStepsModal);



// WEBPACK FOOTER //
// ./src/components/Modal/TwoStepsModal.jsx